import { useTranslation } from 'react-i18next';

import { useGetFreeDailyDiceMutation } from '@/api/queries/game';
import { ToastNotification } from '@/common/components/ToastNotification/ToastNotification';
import { showToast } from '@/components/ui/Notification/SwipeableToastNotification';
import { setDiceCount } from '@/redux/reducers/diceGameReducer';
import { changePaymentStatus } from '@/redux/reducers/paymentsReducer';
import { markFreeDailyDiceClaimed } from '@/redux/reducers/userReducer';
import { useAppDispatch } from '@/redux/store';

import dicePng from '/img/dice-game/dice.png';
import diceWebp from '/img/dice-game/dice.webp';

/** Takes today's free dice (dice shop and the buy-dice window). */
const useClaimFreeDailyDice = (): {
  claim: (options?: { silentStatus?: boolean }) => Promise<void>;
  isClaiming: boolean;
} => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [getFreeDailyDice, { isLoading: isClaiming }] =
    useGetFreeDailyDiceMutation();

  const claim = async (options?: { silentStatus?: boolean }): Promise<void> => {
    if (isClaiming) return;

    try {
      const newDiceCount = await getFreeDailyDice().unwrap();

      dispatch(setDiceCount(newDiceCount));
      dispatch(markFreeDailyDiceClaimed());

      // The buy window switches to its success screen on this status
      if (!options?.silentStatus) dispatch(changePaymentStatus('success'));
      ToastNotification(t('Success. Dice credited and ready to use'), {
        img: dicePng,
        webp: diceWebp,
      });
    } catch (error) {
      console.error(error);
      showToast(t('Something went wrong, please try again'));
    }
  };

  return { claim, isClaiming };
};

export { useClaimFreeDailyDice };
